import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCatchRideFilled = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 12,
	height: 12,
	viewBox: "0 0 12 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M9.13389 11.3086H2.93937V4.27044L6.89874 0.308594L7.17853 0.5914C7.23579 0.649411 7.28421 0.724058 7.32379 0.815341C7.36337 0.906624 7.38274 0.990229 7.38189 1.06616V1.16725L6.73705 4.27044H10.9806C11.2446 4.27044 11.4804 4.3758 11.688 4.58651C11.8956 4.79723 11.9996 5.03653 12 5.30441V6.0914C12 6.14984 11.9941 6.21339 11.9823 6.28207C11.9705 6.35117 11.9531 6.41473 11.9299 6.47274L10.2051 10.615C10.1183 10.8117 9.97242 10.9765 9.76737 11.1096C9.56274 11.2423 9.35158 11.3086 9.13389 11.3086ZM2.30779 4.27044V11.3086H0V4.27044H2.30779Z",
		fill: "#7B61FF"
	})]
});
const ForwardRef = forwardRef(SvgCatchRideFilled);
export { ForwardRef as ReactComponent };
